import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { checkUndefine } from '../../../../../../helpers/functions';
import DEFINE, { CUSTOM_PRICE } from '../../../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
    DatePickerComponent
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import UploadImage from "../../../../common/component/UploadImage";
import Wrapper from "../../../../common/component/Wrapper";
import { Icon } from 'antd';
import './PlaceDetail.less';

class PlaceDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { t, place, disabled, validation, uploading } = this.props;
        return (
            <Wrapper className="place-detail-section">
                <FormWrapperItem>
                    <Wrapper className="col-md-4">
                        <UploadImage
                            multiple={false}
                            loading={uploading}
                            thumbnailSize={'100%'}
                            thumbnailStyle={{ maxHeight: 200 }}
                            buttonSize={150}
                            disabledUpload={disabled}
                            disabledRemove={disabled}
                            uploadText={t('item.popularPlace.uploadFile')}
                            loadingText={t('item.popularPlace.uploading')}
                            onChange={this.props.onUploadImage}
                            onRemoveThumbnail={this.props.onRemoveImage}
                            thumbnails={place.image && this.getThumbSources([place.image])} />
                    </Wrapper>
                    <Wrapper className="col-md-8 row">
                        <Wrapper className="col-md-12 m-0 p-0">
                            <FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={place.name}
                                validation={validation.name}
                                labelTitle={t(`item.popularPlace.name`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`name`} onChange={(e) => this.props.onChange('name', e.target.value)}
                                    value={checkUndefine(place.name)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pr-2">
                            <FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={place.numberOfVacancies}
                                validation={validation.numberOfVacancies}
                                labelTitle={t(`item.popularPlace.numberOfVacancies`)}
                            >
                                <Input placeholder="" type={`number`}
                                    className={`form-control text-right number-input`}
                                    name={`numberOfVacancies`} onChange={(e) => this.props.onChange('numberOfVacancies', e.target.value)}
                                    value={checkUndefine(place.numberOfVacancies)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pl-2">
                            <FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={place.averagePrice}
                                validation={validation.averagePrice}
                                labelTitle={t(`item.popularPlace.averagePrice`)}
                            >
                                <Input placeholder="" type={`number`}
                                    className={`form-control text-right number-input`}
                                    name={`averagePrice`} onChange={(e) => this.props.onChange('averagePrice', e.target.value)}
                                    value={checkUndefine(place.averagePrice)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                    </Wrapper>
                </FormWrapperItem>
            </Wrapper>
        );
    }

    getThumbSources(thumbs) {
        return (thumbs || []).filter(t => t && Object.keys(t).length > 0).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`)
    }

}

PlaceDetail.defaultProps = {
    onChange: () => { },
}

export default withTranslation()(PlaceDetail);
